import React from "react";

/**
 * ServicesGrid — Clean, gap-fixed, blue-themed service section
 * with Font Awesome icons replacing missing custom ones.
 */
export default function ServicesGrid({
  services = [
    {
      title: "Regular Transport",
      iconClass: "fa-solid fa-car",
      bg: "/images/services/1.jpg",
      wowDelay: "200ms",
    },
    {
      title: "City Transport",
      iconClass: "fa-solid fa-city",
      bg: "/images/services/2.jpg",
      wowDelay: "400ms",
    },
    {
      title: "Business Tour",
      iconClass: "fa-solid fa-briefcase",
      bg: "/images/services/3.jpg",
      wowDelay: "600ms",
    },
    {
      title: "Shuttle Service",
      iconClass: "fa-solid fa-van-shuttle",
      bg: "/images/services/4.png",
      wowDelay: "200ms",
    },
    {
      title: "Airport Transport",
      iconClass: "fa-solid fa-plane-departure",
      bg: "/images/services/5.jpg",
      wowDelay: "400ms",
    },
    {
      title: "Holiday Tour",
      iconClass: "fa-solid fa-umbrella-beach",
      bg: "/images/services/6.jpg",
      wowDelay: "600ms",
    },
  ],
}) {
  return (
    <>
      {/* ==== HEADER ==== */}
      <section className="page-header">
        <div
          className="page-header__bg"
          style={{
            backgroundImage: "url(/images/page-header-bg-1-1.jpg)",
          }}
        ></div>
        <div className="container">
          <div className="page-header__content text-center">
            <h2 className="page-header__title">Our Services</h2>
          </div>
        </div>
      </section>

      {/* ==== SERVICES GRID ==== */}
      <section className="services-page section-space" style={{backgroundColor:'#349ECD'}}>
        <div className="container">
          <div className="row g-4">
            {services.map((s, idx) => (
              <div className="col-lg-4 col-md-6" key={idx}>
                <div
                  className="service-card-one wow fadeInUp"
                  data-wow-duration="1500ms"
                  data-wow-delay={s.wowDelay}
                  style={{
                    backgroundImage: `url(${s.bg})`,
                  }}
                >
                  <div className="service-card-one__overlay" />
                  <div className="service-card-one__icon">
                    <i className={s.iconClass}></i>
                  </div>
                  <div className="service-card-one__content">
                    <h3 className="service-card-one__title">
                      <a href={s.href}>{s.title}</a>
                    </h3>
             
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
